"use strict";

var _moduleLocalization = require("@eig-builder/module-localization");

_moduleLocalization.Localizations.append({
  imageSelector: {
    commonSearchTerms: {
      computer: 'Computer',
      work: 'Work',
      business: 'Business',
      woman: 'Woman',
      man: 'Man',
      city: 'City',
      nature: 'Nature',
      animals: 'Animals'
    }
  }
});